import './Toasts.less';
import React from 'react';
import ReactDOM from 'react-dom';
import Toast from "./Toast";
import {getLayoutPortalElement} from "../../dom/element/queries";
import DOMCustomEvents, {EVENT_LAYOUT_READY} from "../../dom/custom-events/DOMCustomEvents";

let instance = null;
let autoIncId = 0;

class Toasts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            toasts: []
        };

        instance = this;
    }

    add = (type, message) => {
        const {toasts} = this.state;

        const id = ++autoIncId;

        toasts.push({id, type, message});

        this.forceUpdate();
    };

    remove = (id) => {
        const {toasts} = this.state;

        let index = toasts.findIndex(t => id === t.id);
        if (index > -1) {
            toasts.splice(index, 1);
        }

        this.forceUpdate();
    };

    render() {
        const {toasts} = this.state;

        if (toasts.length === 0) {
            return null;
        }

        return <div className="toasts">
            {
                toasts.map(({id, type, message}) => {
                    return <Toast
                        key={id}
                        type={type}
                        remove={() => this.remove(id)}
                    >
                        {message}
                    </Toast>;
                })
            }
        </div>;
    }
}


// Export singleton

let initialized = false;

const pendingMessages = [];

function init() {
    if (initialized) {
        return;
    }

    initialized = true;

    const render = () => {
        const container = document.createElement('div');
        container.className = 'toasts-container';
        getLayoutPortalElement().appendChild(container);
        ReactDOM.render(<Toasts/>, container);
        pendingMessages.forEach(([type, message]) => instance.add(type, message));
    };

    if (getLayoutPortalElement()) {
        render();
        return;
    }

    DOMCustomEvents.observe(EVENT_LAYOUT_READY, 'scomponents.Toasts.render', render);
}

export default {
    init: init,
    add: (type, message) => {
        if (instance !== null) {
            instance.add(type, message);
            return;
        }

        pendingMessages.push([type, message]);
    }
}


// Export constants

const TOAST_SUCCESS = 'success';
const TOAST_INFO = 'info';
const TOAST_ERROR = 'error';
const TOAST_WARN = 'warn';

export {
    TOAST_SUCCESS,
    TOAST_INFO,
    TOAST_ERROR,
    TOAST_WARN
};
